import { Employee } from 'types/components/FixBidCalculator';
import { v4 as uuid } from 'uuid';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getDefaultTeam = (
  isStaging: boolean,
  employees: Employee[],
  isDMorAdmin: boolean,
  defaultExperiences: Record<string, number>,
) =>
  isDMorAdmin && isStaging
    ? [
        /* {
          id: uuid(),
          role: 'Freelancer',
          control: 'rate',
          customRate: 0,
          hours: { billable: 0 },
        },
        {
          id: uuid(),
          role: 'Junior Developer',
          control: 'rate',
          customRate: +defaultExperiences['Junior Developer'].toFixed(4),
          hours: { billable: 0 },
        },
        {
          id: uuid(),
          role: 'Middle Developer',
          control: 'rate',
          customRate: +defaultExperiences['Middle Developer'].toFixed(4),
          hours: { billable: 0 },
        },
        {
          id: uuid(),
          role: 'Senior Developer',
          control: 'rate',
          customRate: +defaultExperiences['Senior Developer'].toFixed(4),
          hours: { billable: 0 },
        },*/
        {
          id: uuid(),
          role: 'Senior Developer',
          control: 'rate',
          customRate: 20,
          _customRate: +defaultExperiences['Senior Developer'].toFixed(4),
          hours: { billable: 100 },
        },
        /* {
          id: uuid(),
          role: 'Product manager',
          control: 'employeeSelect',
          employee: employees[0],
          hours: { billable: 0 },
        },*/
        {
          id: uuid(),
          role: 'Project Lead',
          _control: 'employeeSelect',
          _employee: employees[0],
          control: 'rate',
          customRate: 10,
          hours: { billable: 100 },
        },
        /* {
          id: uuid(),
          role: 'Coordinator',
          control: 'employeeSelect',
          employee: employees[0],
          hours: { billable: 0 },
        },
        {
          id: uuid(),
          role: 'DevOps',
          control: 'employeeSelect',
          employee: employees[0],
          hours: { billable: 0 },
        },
        {
          id: uuid(),
          role: 'QA',
          control: 'employeeSelect',
          employee: employees[0],
          hours: { billable: 0 },
        },
        {
          id: uuid(),
          role: 'Developer',
          control: 'employeeSelect',
          employee: employees[0],
          hours: { billable: 0 },
        },*/
      ]
    : [];
